import * as types from "./../types";

const setError = (error) => ({
  type: types.VIEW_ERROR,
  error,
});
export const funcSaveVkycStatus = (vkycStatus) => async (dispatch) => {
  dispatch({
    type: types.SAVE_VKYC_STATUS,
    payload: { vkycStatus: vkycStatus },
  });
}
export const funcSaveIngestion2ServiceResponse =
  (response) => async (dispatch) => {
    try {
      //const response = await CardDetails.funcFetchCardDetails(cardPath);

      dispatch({
        type: types.SAVE_INGESTION2_RESPONSE,
        payload: { ...response.data, statusCode: response.statusCode },
      });

      if (response.data && response.data?.hsToken) {
        localStorage.setItem("hsToken", response.data.hsToken);
      }

    } catch (err) {
      dispatch(setError("Error fetching card details..."));
    }
  };
